<template>
  <div class="personalPageWrap">
    <div class="personal" v-swipeup="(e) => vueTouch('上滑', e)">
      <div class="commonBg" v-if="$padFalg == 'other'"></div>
      <div class="personal_top">
        <div class="topimgwrap">
          <div class="topimg">
            <img
              v-if="$store.state.gameType == 1"
              src="@/assets/img/userPage/header_bg.jpg"
              alt=""
            />
            <img
              v-if="$store.state.gameType == 2"
              src="@/assets/img/gl/header_bg.jpg"
              alt=""
            />
            <img
              v-if="$store.state.gameType == 3"
              src="@/assets/img/dqss/new/header_bg2.jpg"
              alt=""
            />
            <img
              v-if="$store.state.gameType == 4"
              src="@/assets/img/lhlr/header_bg.jpg"
              alt=""
            />
          </div>
          <div class="topimgwrap_iconbox">
            <div
              v-show="page == 'otherHome'"
              class="topimgwrap_backicon topimgwrap_icon"
              @click="backClick"
            ></div>
            <div
              v-show="page == 'userPage' && $store.state.loginStatus !== 0"
              class="topimgwrap_setUpicon topimgwrap_icon"
              @click="gouserSet"
            ></div>
            <div
              v-show="
                page == 'userPage' &&
                $store.state.bindIconShow &&
                $store.state.isInGame &&
                !$store.state.isXcx
              "
              class="bind_icon"
              @click="gouserSet(1)"
            ></div>
            <div
              class="topimgwrap_closeicon topimgwrap_icon"
              v-show="
                this.$store.state.system == 'android' &&
                applets != 'xcx' &&
                !$store.state.isXcx &&
                this.$store.state.isInGame
              "
              @click="closeCommunity"
            ></div>
          </div>
        </div>
        <!-- 关注 -->
        <div class="personal_information">
          <div class="personal_information_top">
            <div class="personal_information_topimgbox">
              <img
                :src="user.avatar"
                @error="defImg()"
                alt=""
                class="userPhoto avatar"
                @click="dosomething"
              />
              <!-- <div
                v-show="user.isOfficial == 3"
                class="reply_item_headbox_icon"
              ></div> -->
            </div>
            <div
              class="levelIconbox"
              v-if="
                $route.name == 'otherHome' || $store.state.loginStatus !== 0
              "
            >
              <p class="userName nick_name">{{ user.nick_name }}</p>
              <!-- <div v-show="user.isOfficial != 3">社区ID：{{ user.id }}</div> -->
              <levelIcon
                :level="user.memberLevel ? user.memberLevel : 0"
              ></levelIcon>
            </div>

            <div
              v-show="user.isOfficial == 3"
              class="personal_officialtext title"
            >
              <p></p>
              官方认证：{{ user.auth_info }}
            </div>
            <div
              v-show="user.isOfficial !== 3 && user.auth_info"
              class="personal_officialtext user title"
            >
              <p></p>
              个人认证：{{ user.auth_info }}
            </div>
            <div class="introduce m20" v-show="user.introduce">
              {{ user.introduce }}
            </div>
            <div
              v-show="!user.introduce && user.isOfficial !== 3 && isMe"
              @click="toUserIntroduce"
              class="m20"
            >
              点击这里，填写个性签名
            </div>
            <div
              class="m20"
              v-show="
                $route.name == 'otherHome' || $store.state.loginStatus !== 0
              "
            >
              IP属地：{{ user.ipLocation }}
            </div>
            <div class="userFans">
              <div
                v-for="item in informList"
                :key="item.id"
                @click="golistPage(item)"
              >
                <p>
                  <span class="empty" v-if="item.id != 0"></span>{{ item.num }}
                  <span>{{ item.name }}</span
                  ><span class="empty" v-if="item.id != 3"></span
                  ><span v-if="item.id != 3">|</span>
                </p>
              </div>
            </div>
            <!-- <div
              class="personalPageWrap_taskbox"
              v-show="page != 'otherHome'"
              v-if="$store.state.gameType == '3' && $store.state.integralFlag"
            >
              <div
                class="
                  personalPageWrap_taskbox_left personalPageWrap_taskbox_div
                "
                @click="goTask()"
              >
                <div class="personalPageWrap_taskbox_left_icon"></div>
                <div class="personalPageWrap_taskbox_div_text">
                  <P class="personalPageWrap_taskbox_div_text_title"
                    >我的任务</P
                  >
                  <P v-show="integral">{{ integral }}积分待领取</P>
                </div>
              </div>
              <div
                class="
                  personalPageWrap_taskbox_right personalPageWrap_taskbox_div
                "
                @click="goExchangeCenter()"
              >
                <div class="personalPageWrap_taskbox_right_icon"></div>
                <div class="personalPageWrap_taskbox_div_text">
                  <P class="personalPageWrap_taskbox_div_text_title"
                    >兑换中心</P
                  >
                  <P v-show="newGift">{{ newGift }}</P>
                </div>
              </div>
            </div> -->
          </div>
          <div class="personal_information_rightbox">
            <div
              class="personal_information_right"
              @click="goeditData"
              v-if="setUp"
            >
              <!-- <p></p> -->
              {{ $store.state.loginStatus === 0 ? '登录/注册' : '编辑资料' }}
            </div>
            <div
              class="listPageContent_btn"
              v-show="!user.isFollow && !setUp"
              @click.stop="focusClick()"
            >
              +关注
            </div>
            <div
              class="listPageContent_btn listPageContent_curbtn"
              v-show="user.isFollow && !setUp"
              @click.stop="focusClick()"
            >
              已关注
            </div>
          </div>
        </div>
      </div>
      <div class="personal_hometitle">主页</div>
      <!-- 已發布帖子 -->
      <van-pull-refresh
        v-model="refreshing"
        success-text="刷新成功"
        :disabled="$store.state.loginStatus === 0 ? true : false"
        @refresh="onRefresh"
      >
        <div class="listPage_emptyicon" v-show="topicsList.length == 0">
          <div class="listPage_emptyicon_icon"></div>
          <div class="listPage_emptyicon_text">
            {{ page == 'otherHome' ? '这里空空如也' : '快来發布第一个帖子吧' }}
          </div>
        </div>
        <van-list
          v-show="topicsList.length != 0"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <card
            v-for="item in topicsList"
            :key="item.id"
            :cardData="item"
            :personalPage="page"
            @removeCardCommon="removeCardCommon"
          ></card>
        </van-list>
      </van-pull-refresh>
    </div>
    <sideRight v-if="$padFalg != 'other'"></sideRight>
  </div>
</template>

<script>
import card from '../../card';
import get from '@/api/get';
import { Toast } from 'vant';
import { Icon } from 'vant';
import getTime from '../../../utils/time';
import * as _code from '../../../utils/code';
import { mapState } from 'vuex';
import arrNewSet from '@/utils/arrNewSet';
import sideRight from '@/components/sideRight';
import numberFormat from '@/utils/numberFormat';
import levelIcon from '@/components/task/levelIcon.vue';

export default {
  name: 'personal',
  props: {
    setUp: {
      type: Boolean,
      default: false
    },
    page: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      integral: '',
      newGift: '',
      applets: window.user.weixcode ? 'xcx' : '',
      defaultImg:
        this.$store.state.gameType != 1
          ? 'https://media.tentree-games.com/media/pictures/community/img/header.webp'
          : 'https://media.tentree-games.com/media/pictures/community/img/header.webp',
      user: {
        avatar: ''
      },
      memberName: '',
      attention: '1',
      getProfile: '',
      topicsList: [],
      dropDown: '', //下拉刷新判断
      informList: [
        { id: 0, name: '粉丝', num: 0 },
        { id: 1, name: '关注', num: 0 },
        { id: 2, name: '获赞', num: 0 },
        { id: 3, name: '收藏', num: 0 }
      ],
      refreshing: false,
      loading: false,
      finished: false,
      userInfo: {
        pageNo: 1,
        pageSize: 10,
        sortType: 4,
        queryType: 5
      },
      isMe: false
    };
  },
  components: {
    [Icon.name]: Icon,
    card,
    sideRight,
    levelIcon
  },
  computed: {
    ...mapState({
      token: 'token'
    })
  },
  watch: {
    token(ne, ol) {
      this.init();
    },
    $route(to, from) {
      //不是从帖子详情页返回才调用init
      // console.log(to, from, '路由的详情')
      if (to.name === 'subjectPage') return;
      if (from.name != 'topicPage' && to.name != 'topicPage') {
        if (from.name != 'userPage' && to.name != 'homePage') {
          if (!this.$route.path.includes('guidePage')) {
            //防止触发登录弹窗
            this.init();
          }
        }
      }
    }
  },
  activated() {
    if (this.$route.name != 'otherHome') {
      //不在他人主页调起
      this.notobtain();
    }
  },
  mounted() {
    this.init();
    if (this.$route.name != 'otherHome') {
      //不在他人主页调起
      this.notobtain();
    }
  },
  methods: {
    defImg() {
      //图片错误展示默认图片
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
    goTask() {
      this.$router.push('/task');
    },
    goExchangeCenter() {
      this.$router.push({
        path: '/exchangeCenter',
        query: {
          type: 'needLoad'
        }
      });
    },
    notobtain() {
      let _this = this;
      get.notobtain().then((res) => {
        if (res === undefined) return;
        if (res.data?.data) {
          let data = res.data.data;
          _this.integral = data.score;
        }
      });
      get.subTitle().then((res) => {
        if (res === undefined) return;

        if (res.data?.data) {
          _this.newGift = res.data.data.subTitle;
        }
      });
    },
    init() {
      if (
        this.$route.query.id ||
        (this.$route.query.roleId &&
          this.$route.query.roleId != window.user.roleid)
      ) {
        this.$route.query.roleId
          ? (this.user.id = this.$route.query.roleId)
          : (this.user.id = this.$route.query.id);
        if (this.$store.state.token) {
          this.getOtherInfo();
        }
      } else {
        if (this.$store.state.token) {
          console.log('是调用的这里的吗');
          this.getInfo();
        }
      }
    },
    //消息设置
    gouserSet(val) {
      if (val == 1) {
        this.$router.push({ name: 'userSet', params: { code: true } });
      } else {
        this.$router.push({ name: 'userSet' });
      }
    },
    onRefresh() {
      console.log('刷新');
      this.topicsList = [];
      this.dropDown = 'dropDown';
      this.init();
    },
    onLoad() {
      let _this = this;
      setTimeout(() => {
        this.getTopics(this.userInfo, function (data) {
          _this.loading = false;
          if (data.length < 10) {
            _this.finished = true;
            _this.userInfo.pageNo > 1 ? _this.userInfo.pageNo-- : 1;
          }
        });
      }, 1000);
    },
    vueTouch(text, e) {
      this.finished = false;
      this.loading = true;
      setTimeout(() => {
        this.onLoad();
      }, 1000);
    },
    backClick() {
      this.$router.go(-1);
    },
    //获取本人
    getInfo() {
      let _this = this;
      if (
        (this.$route.query.source != 'tab' || this.userInfo.pageNo == 1) &&
        _this.$route.name == 'userPage'
      ) {
        this.topicsList = [];
      }
      // 获取个人信息（关注数&粉丝）
      get.getProfile().then((res) => {
        console.log(res, '获取本人的信息');
        if (res === undefined) return;
        if (res.data.code == 0) {
          this.isMe = true;
          var _data = res.data.data;
          this.user = _data;
          this.user.fans = numberFormat(this.user.fans);
          this.user.follows = numberFormat(this.user.follows);
          this.user.likes = numberFormat(this.user.likes);
          this.user.favors = numberFormat(this.user.favors);
          this.informList[0].num = this.user.fans;
          this.informList[1].num = this.user.follows;
          this.informList[2].num = this.user.likes;
          this.informList[3].num = this.user.favors;
          _this.userInfo.queryType = 5;
          _this.userInfo.memberId = null;
          if (this.dropDown == 'dropDown') {
            // Toast("刷新成功");
            _this.userInfo.pageNo = 1;
            this.dropDown == '';
          }
          if (
            (this.$route.query.source != 'tab' || this.userInfo.pageNo == 1) &&
            _this.$route.name == 'userPage'
          ) {
            this.getTopics(this.userInfo);
          }
        } else {
          this.errorMessage(res.data);
          this.user = {
            avatar: this.defaultImg
          };
        }
      });
      // 获取个人帖子列表
      // get.getTopics(userInfo).then((res) => {
      //   var _data = res.data.data.list;
      //   _data.forEach((n, i) => {
      //     this.topicsList.push(n);
      //   });
      //   getTime(this.topicsList);
      //   this.refreshing = false;
      // });
    },
    // 获取帖子列表
    getTopics(userInfo, cb) {
      let _this = this;
      get.getTopics(userInfo).then((res) => {
        var _data = res.data.data.list;
        _this.topicsList = _this.topicsList.concat(_data);
        _this.topicsList = arrNewSet(_this.topicsList);
        _this.topicsList.forEach((n, i) => {
          n.partitionShow = true;
        });
        getTime(_this.topicsList);

        _this.refreshing = false;
        if (_this.userInfo.pageNo == 1) {
          if (_data.length < 10) {
            _this.userInfo.pageNo = 1;
          } else {
            _this.userInfo.pageNo++;
          }
        } else {
          _this.userInfo.pageNo++;
        }
        cb && cb(_data);
      });
    },
    golistPage(item) {
      if (this.$store.state.loginStatus === 0) return;
      switch (item.id) {
        case 0:
          this.$router.push({
            name: 'listPage',
            query: {
              type: 'fans',
              id: this.$route.query.id,
              user: this.setUp
            }
          });
          break;
        case 1:
          this.$router.push({
            name: 'listPage',
            query: {
              type: 'follows',
              id: this.$route.query.id,
              user: this.setUp
            }
          });
          break;
        case 3:
          if (this.$route.query.id) {
            return;
          }
          this.$router.push({
            name: 'listPage',
            query: { type: 'topics', user: this.setUp }
          });
          break;
        default:
          break;
      }
    },
    //前往编辑资料
    goeditData() {
      if (this.$store.state.loginStatus === 0) {
        this.$store.commit('changeLoginShow', true);
        return;
      }
      this.$router.push({
        name: 'editData',
        query: { name: this.user.nick_name, img: this.user.avatar }
      });
    },
    // 前往个性签名
    toUserIntroduce() {
      if (this.$store.state.postingFlag) {
        this.$router.push({
          name: 'editData',
          query: {
            name: this.user.nick_name,
            img: this.user.avatar,
            page: 'sign',
            jump: true
          }
        });
      } else {
        Toast('当前无法修改个性签名');
      }
    },
    getOtherInfo() {
      let _this = this;
      // 获取他人个人信息
      this.userInfo.queryType = 5;
      this.userInfo.memberId = this.user.id;
      if (this.$route.query.newpage) {
        _this.topicsList = [];
        _this.userInfo.pageNo = this.$route.query.pageNo;
        _this.finished = false;
      }
      get.getOtherProfile(this.user.id).then((res) => {
        if (res.data.code == 0) {
          this.isMe = false;
          var _data = res.data.data;
          this.user = _data;
          this.user.fans = numberFormat(this.user.fans);
          this.user.follows = numberFormat(this.user.follows);
          this.user.likes = numberFormat(this.user.likes);
          this.user.favors = numberFormat(this.user.favors);
          this.informList[0].num = this.user.fans;
          this.informList[1].num = this.user.follows;
          this.informList[2].num = this.user.likes;
          this.informList[3].num = this.user.favors;
          if (this.dropDown == 'dropDown') {
            // Toast("刷新成功");
            this.dropDown == '';
            _this.userInfo.pageNo = 1;
          }
        } else {
          // this.errorMessage(res.data);
        }
      });
      // 获取个人帖子列表
      this.getTopics(this.userInfo);
      // get.getTopics(userInfo).then((res) => {
      //   var _data = res.data.data.list;
      //   _data.forEach((n, i) => {
      //     this.topicsList.push(n);
      //   });
      //   getTime(this.topicsList);
      //   this.refreshing = false;
      // });
    },
    //关注&&取消关注
    focusClick() {
      get.follow(this.user.id).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.user.isFollow = !this.user.isFollow;
          // if (this.user.isFollow) {
          //   Toast("关注成功");
          // } else {
          //   Toast("关注成功");
          // }
        } else {
          this.errorMessage(data);
        }
      });
    },
    // 编辑个人信息
    dosomething: function () {
      console.log(1);
    },
    // card_common删除帖子
    removeCardCommon() {
      let _this = this;
      _this.getInfo();
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  }
};
</script>

<style scoped></style>